import actionCreatorFactory from "typescript-fsa";
import { reducerWithInitialState } from "typescript-fsa-reducers";
import { Group } from "../types/types";
import { RootState } from "./index.store";

/* Selectors */
/**
 * 全てのグループを返す
 * @param state
 */
export const groupsSelector = (state: RootState) => state.domain.groups;

/* Actions */
const actionCreator = actionCreatorFactory("groups");
export const groupsActions = {
  /* SYSTEM ACTIONS */
  SYSTEM_FETCH_ALL_GROUPS: actionCreator("SYSTEM_FETCH_ALL_GROUPS"),
  /* USER ACTIONS */
  /* REDUCER ACTIONS */
  REDUCER_SET_GROUPS: actionCreator<Group[]>("REDUCER_SET_GROUPS")
};

/**
 * グループリデューサー
 */
export const groupsReducer = reducerWithInitialState<Group[]>([]).case(
  groupsActions.REDUCER_SET_GROUPS,
  (state, payload) => payload
);
